import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Loader2, Save } from "lucide-react";

/** Turn a textarea value into clean array lines (bullets stripped). */
export function linesToArray(text: string): string[] {
  return (text || "")
    .split("\n")
    .map((l) => l.replace(/^[•\-*]\s*/, "").trim())
    .filter((l) => l.length > 0);
}

/** Turn stored array lines back into a textarea value. */
export function arrayToLines(arr: string[] | null | undefined): string {
  return (arr || []).join("\n");
}

interface ItemInclusionsExclusionsFieldsProps {
  inclusions: string;
  exclusions: string;
  onInclusionsChange: (value: string) => void;
  onExclusionsChange: (value: string) => void;
  /** When provided, shows a "save back to source" action (product / property). */
  onSaveToSource?: () => void;
  saveToSourceLabel?: string;
  isSavingToSource?: boolean;
}

export function ItemInclusionsExclusionsFields({
  inclusions,
  exclusions,
  onInclusionsChange,
  onExclusionsChange,
  onSaveToSource,
  saveToSourceLabel,
  isSavingToSource = false,
}: ItemInclusionsExclusionsFieldsProps) {
  return (
    <div className="space-y-3 rounded-md border p-3 bg-muted/30">
      <div className="flex items-start justify-between gap-2">
        <p className="text-xs text-muted-foreground">
          One point per line. These pull through to the quote — under this item and into the
          overall Included / Not Included lists.
        </p>
        {onSaveToSource && (
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="h-7 text-xs gap-1 whitespace-nowrap"
            onClick={onSaveToSource}
            disabled={isSavingToSource}
          >
            {isSavingToSource ? (
              <Loader2 className="h-3 w-3 animate-spin" />
            ) : (
              <Save className="h-3 w-3" />
            )}
            {saveToSourceLabel || "Save as default"}
          </Button>
        )}
      </div>

      <div className="space-y-2">
        <Label htmlFor="item_inclusions" className="text-sm">
          Inclusions
        </Label>
        <Textarea
          id="item_inclusions"
          value={inclusions}
          onChange={(e) => onInclusionsChange(e.target.value)}
          rows={3}
          placeholder={"Entrance fees\nEnglish-speaking guide\nBottled water"}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="item_exclusions" className="text-sm">
          Exclusions
        </Label>
        <Textarea
          id="item_exclusions"
          value={exclusions}
          onChange={(e) => onExclusionsChange(e.target.value)}
          rows={3}
          placeholder={"Drinks\nGratuities\nOptional cable car ticket"}
        />
      </div>
    </div>
  );
}
